/* ========================================
   GRANDMAA MILLETS — MAIN JS
   Version: 1.0.0
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  const root = document.documentElement;
  const topbar = document.querySelector('.topbar');
  const siteHeader = document.getElementById('site-header');

  function updateHeaderStackHeight() {
    const topbarHeight = topbar ? Math.round(topbar.getBoundingClientRect().height) : 0;
    const headerHeight = siteHeader ? Math.round(siteHeader.getBoundingClientRect().height) : 0;

    root.style.setProperty('--announcement-height', `${topbarHeight}px`);
    root.style.setProperty('--site-header-height', `${headerHeight}px`);
    root.style.setProperty('--header-stack-height', `${topbarHeight + headerHeight}px`);
  }

  updateHeaderStackHeight();
  window.addEventListener('resize', updateHeaderStackHeight, { passive: true });

  if (window.ResizeObserver) {
    const headerStackObserver = new ResizeObserver(updateHeaderStackHeight);
    if (topbar) headerStackObserver.observe(topbar);
    if (siteHeader) headerStackObserver.observe(siteHeader);
  }

  // ---- MOBILE MENU ----
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const closeMobileMenu = document.getElementById('close-mobile-menu');
  const mobileOverlay = document.getElementById('mobile-overlay');

  function openMobileMenu() {
    mobileMenu.classList.add('open');
    mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenuFn() {
    mobileMenu.classList.remove('open');
    mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileMenu);
  if (closeMobileMenu) closeMobileMenu.addEventListener('click', closeMobileMenuFn);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenuFn);

  document.querySelectorAll('.mobile-nav-summary-link').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileMenuFn();
      window.location.href = this.href;
    });
  });

  document.querySelectorAll('.mobile-nav-toggle').forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const details = this.closest('.mobile-nav-details');
      if (!details) return;
      details.open = !details.open;
    });
  });

  // ---- SEARCH TOGGLE & PREDICTIVE SEARCH ----
  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');
  const closeSearch = document.getElementById('close-search');
  const searchInput = searchBar ? searchBar.querySelector('.search-input') : null;
  const searchSuggestions = document.getElementById('search-suggestions');
  let activeRequestId = 0;

  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      searchBar.classList.toggle('open');
      if (searchBar.classList.contains('open') && searchInput) {
        searchInput.focus();
      }
    });
  }

  if (closeSearch) {
    closeSearch.addEventListener('click', () => {
      searchBar.classList.remove('open');
      clearSuggestions();
    });
  }

  function clearSuggestions() {
    if (searchSuggestions) {
      searchSuggestions.innerHTML = '';
      searchSuggestions.style.display = 'none';
    }
  }

  if (searchInput && searchSuggestions) {
    let debounceTimer;

    searchInput.addEventListener('input', function() {
      const query = this.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < 3) {
        clearSuggestions();
        return;
      }

      // Show loader
      searchSuggestions.innerHTML = `
        <div class="search-suggestions-loading">
          <div class="search-suggestions-spinner"></div>
          <span>Searching...</span>
        </div>
      `;
      searchSuggestions.style.display = 'block';

      debounceTimer = setTimeout(() => {
        activeRequestId += 1;
        fetchSuggestions(query, activeRequestId);
      }, 300);
    });

    // Close on escape key
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        clearSuggestions();
        searchBar.classList.remove('open');
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (searchBar && !searchBar.contains(e.target) && searchToggle && !searchToggle.contains(e.target)) {
        clearSuggestions();
        searchBar.classList.remove('open');
      }
    });
  }

  function fetchSuggestions(query, requestId) {
    const localePrefix = window.Shopify && window.Shopify.locale ? `/${window.Shopify.locale}` : '';
    const url = `${localePrefix}/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,query,collection&resources[limit]=4&resources[limit_scope]=each&section_id=predictive-search`;

    fetch(url)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.text();
      })
      .then(text => {
        if (requestId !== undefined && requestId !== activeRequestId) {
          return;
        }

        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(text, 'text/html');
        // Query both the shopify section container and the inner results element as fallback
        const results = htmlDoc.getElementById('shopify-section-predictive-search') || htmlDoc.getElementById('predictive-search-results');
        
        if (results && results.innerHTML.trim() !== '') {
          searchSuggestions.innerHTML = results.innerHTML;
        } else {
          searchSuggestions.innerHTML = `
            <div class="search-suggestions-no-results">
              No results found for "${escapeHtml(query)}"
            </div>
          `;
        }
        searchSuggestions.style.display = 'block';
      })
      .catch(err => {
        console.error('Predictive Search fetch error:', err);
        clearSuggestions();
      });
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // ---- CART DRAWER ----
  const openCartBtn = document.getElementById('open-cart');
  const closeCartBtn = document.getElementById('close-cart');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (openCartBtn) openCartBtn.addEventListener('click', openCart);
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---- FETCH CART ----
  function fetchCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemsContainer = document.getElementById('cart-drawer-items');
        const totalEl = document.getElementById('cart-total-price');

        updateCartCountBadge(cart.item_count);
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

        if (!itemsContainer) return;
        if (cart.item_count === 0) {
          itemsContainer.innerHTML = '<div style="text-align:center;padding:40px;color:var(--text-light)"><p style="font-size:40px;color:var(--accent)"><i class="ti ti-shopping-cart"></i></p><p>Your cart is empty</p><a href="/collections/all" style="color:var(--primary);font-weight:600">Shop Now &rarr;</a></div>';
          return;
        }

        itemsContainer.innerHTML = cart.items.map(item => `
          <div class="cart-item" style="padding:14px 0;border-bottom:1px solid var(--border);display:flex;gap:12px">
            <img src="${item.image}" alt="${item.title}" style="width:70px;height:70px;object-fit:cover;border-radius:6px">
            <div style="flex:1">
              <p style="font-size:13px;font-weight:500;margin-bottom:4px">${item.product_title}</p>
              ${item.variant_title !== 'Default Title' ? `<p style="font-size:11px;color:var(--text-light)">${item.variant_title}</p>` : ''}
              ${item.original_line_price > item.final_line_price ? `<p style="font-size:11px;color:#999;margin-top:6px"><span style="font-weight:600;color:var(--text-light)">MRP</span> <s>${formatMoney(item.original_line_price)}</s></p>` : ''}
              <p style="font-size:14px;font-weight:700;color:var(--primary);margin-top:4px">${formatMoney(item.final_line_price)}</p>
              ${item.original_line_price > item.final_line_price ? `<p style="font-size:11px;color:var(--success);margin-top:3px">You save ${formatMoney(item.original_line_price - item.final_line_price)}</p>` : ''}
            </div>
            <button onclick="removeFromCart('${item.key}')" style="background:none;border:none;color:var(--accent);font-size:18px;cursor:pointer;align-self:flex-start">&times;</button>
          </div>
        `).join('');
      })
      .catch(err => console.error('Cart fetch error:', err));
  }

  function formatMoney(cents) {
    return '\u20B9' + (cents / 100).toFixed(0);
  }

  function updateCartCountBadge(itemCount) {
    const countEl = document.getElementById('cart-count');
    if (!countEl) return;

    countEl.textContent = itemCount;
    countEl.style.display = itemCount > 0 ? 'inline-flex' : 'none';
  }

  function resetAddToCartButton(btn, originalHtml) {
    if (!btn) return;
    btn.disabled = false;
    btn.innerHTML = originalHtml;
    btn.style.background = '';
  }

  function addVariantToCart(variantId, quantity) {
    return fetch('/cart.js')
      .then(res => {
        if (!res.ok) {
          throw new Error(`Cart fetch failed: ${res.status}`);
        }
        return res.json();
      })
      .then(cart => {
        const existingItem = cart.items.find(item =>
          Number(item.variant_id) === Number(variantId) &&
          (!item.properties || Object.keys(item.properties).length === 0) &&
          !item.selling_plan_allocation
        );

        if (existingItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: existingItem.key,
              quantity: existingItem.quantity + quantity
            })
          });
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });
      })
      .then(res => {
        if (!res.ok) {
          throw new Error(`Cart update failed: ${res.status}`);
        }
        return res.json();
      });
  }

  // ---- ADD TO CART ----
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.quick-add-btn, #add-to-cart-btn');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const qtyInput = document.getElementById('qty');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1;
    const originalHtml = btn.innerHTML;

    btn.disabled = true;
    btn.innerHTML = '<i class="ti ti-loader"></i> Adding...';

    addVariantToCart(variantId, safeQty)
    .then(() => {
      btn.innerHTML = '<i class="ti ti-check"></i> Added!';
      btn.style.background = 'var(--accent)';
      fetchCart();
      setTimeout(() => {
        resetAddToCartButton(btn, originalHtml);
      }, 1200);
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      resetAddToCartButton(btn, originalHtml);
    });
  });

  // ---- BUY NOW ----
  const buyNowBtn = document.getElementById('buy-now-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() {
      const addCartBtn = document.getElementById('add-to-cart-btn');
      const variantId = addCartBtn ? addCartBtn.dataset.variantId : null;
      if (!variantId) return;
      const qty = document.getElementById('qty') ? parseInt(document.getElementById('qty').value, 10) : 1;
      const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1;
      addVariantToCart(variantId, safeQty).then(() => { window.location.href = '/checkout'; });
    });
  }

  // ---- REMOVE FROM CART ----
  window.removeFromCart = function(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(() => fetchCart());
  };

  // ---- STICKY HEADER ----
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 100) {
        header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.2)';
      } else {
        header.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
      }
      header.style.transform = 'translateY(0)';
      header.style.top = 'var(--announcement-height, 37px)';
    }, { passive: true });
  }

  // ---- INITIAL CART COUNT ----
  fetch('/cart.js').then(r => r.json()).then(cart => {
    updateCartCountBadge(cart.item_count);
  });

  // ---- SEARCH FORM WILDCARD MODIFIER ----
  // Append * to search query on submission for prefix matching
  document.addEventListener('submit', function(e) {
    const searchForm = e.target.closest('form[action="/search"], form[action*="/search"]');
    if (!searchForm) return;

    const qInput = searchForm.querySelector('input[name="q"]');
    if (!qInput) return;

    let query = qInput.value.trim();
    if (query.length > 0 && !query.endsWith('*')) {
      qInput.value = query + '*';
    }
  });

  // Strip trailing * from search inputs on load so it looks clean to the user
  document.querySelectorAll('input[name="q"]').forEach(input => {
    let val = input.value;
    if (val.endsWith('*')) {
      input.value = val.slice(0, -1);
    }
  });

});





